module.exports = __webpack_public_path__ + "img/Jc.ca1a5101.png";